import type {ReactNode} from 'react';
import {createElement} from 'react';
import {
  CrownOutlined,
  IdcardOutlined,
  RocketOutlined,
  SafetyOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  SoundOutlined,
  StarOutlined,
  TeamOutlined,
} from '@ant-design/icons';

import type {Permission, UserRole} from '@services/auth';

export const ROLE_LABEL: Record<UserRole, string> = {
  SUPER_ADMIN: 'Супер Админ',
  ADMIN: 'Админ',
  MANAGER: 'Менеджер',
  ORGANIZER: 'Организатор',
  ACCOUNTANT: 'Бухгалтер',
  SUPER_CASHIER: 'Супер-кассир',
  CASHIER: 'Кассир',
  PARTNER: 'Партнёр',
  ARTIST: 'Артист',
  CONTROLLER: 'Контроллёр',
  THEATER_CONTROLLER: 'Контроллёр по площадкам',
  EVENT_CONTROLLER: 'Контроллёр по событиям',
};

export const ROLE_ICON: Record<UserRole, ReactNode> = {
  SUPER_ADMIN: createElement(CrownOutlined),
  ADMIN: createElement(SafetyOutlined),
  MANAGER: createElement(StarOutlined),
  ORGANIZER: createElement(RocketOutlined),
  ACCOUNTANT: createElement(IdcardOutlined),
  SUPER_CASHIER: createElement(ShoppingCartOutlined),
  CASHIER: createElement(ShoppingCartOutlined),
  PARTNER: createElement(TeamOutlined),
  ARTIST: createElement(SoundOutlined),
  CONTROLLER: createElement(ShopOutlined),
  THEATER_CONTROLLER: createElement(ShopOutlined),
  EVENT_CONTROLLER: createElement(SoundOutlined),
};

// Краткое описание permission'а: organization → theater → event → country.
export const describePermission = (p: Permission): string[] => {
  const parts: string[] = [];
  if (p.organization?.title) parts.push(p.organization.title);
  if (p.theater?.title) parts.push(p.theater.title);
  if (p.event?.title) parts.push(p.event.title);
  if (p.country?.title) parts.push(p.country.title);
  return parts;
};
